import { render } from "./ReviewChangeProposalsModal.vue?vue&type=template&id=6e8cd22a&scoped=true"
import script from "./ReviewChangeProposalsModal.vue?vue&type=script&lang=js"
export * from "./ReviewChangeProposalsModal.vue?vue&type=script&lang=js"

import "./ReviewChangeProposalsModal.vue?vue&type=style&index=0&id=6e8cd22a&lang=scss"
import "./ReviewChangeProposalsModal.vue?vue&type=style&index=1&id=6e8cd22a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8cd22a"]])

export default __exports__